import {Box, Flex, Text} from '@chakra-ui/react';
import styled from '@emotion/styled';
import {FC, Fragment} from 'react';
import {Dividers, SchemaType, UnitLabels} from '../../CountdownDefinition';

export type CountdownUnitPropsBase = Pick<
  SchemaType,
  'divider' | 'isUnitUnderNum' | 'typography'
>;

interface CountdownUnitProps extends CountdownUnitPropsBase {
  typedUnit: keyof UnitLabels;
  timeValue?: number;
  unitLabel: string;
  withDivider?: boolean;
}

const Numeral = styled.span`
  display: inline-block;
  width: 1ch;
  text-align: center;
`;

export const CountdownUnit: FC<CountdownUnitProps> = (props) => {
  const {
    typography = {},
    isUnitUnderNum,
    timeValue,
    typedUnit,
    unitLabel,
  } = props;
  const displayValue = `${timeValue ?? 0}`.padStart(2, '0');
  const numerals = displayValue.split('');
  return (
    <Fragment key={typedUnit}>
      <Box
        className={`countdown-${typedUnit}-wrapper`}
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection={isUnitUnderNum ? `column` : `row`}
      >
        <Text
          fontWeight="100"
          fontFamily={typography.fontFamily}
          lineHeight="1"
          className="number"
          margin={`0 ${isUnitUnderNum ? 0 : '0.625'}rem ${
            isUnitUnderNum ? '0.625' : 0
          }rem 0`}
          fontSize={typography.clockFontSize}
          color={typography.primaryTextColor}
          minWidth={`${numerals.length}ch`}
          textAlign="center"
          whiteSpace="nowrap"
        >
          {numerals.map((numeral, i) => (
            <Numeral key={i}>{numeral}</Numeral>
          ))}
        </Text>
        <Text
          fontWeight="500"
          className="unit"
          fontSize={typography.unitFontSize}
          fontFamily={typography.fontFamily}
          color={typography.primaryTextColor}
        >
          {unitLabel}
        </Text>
      </Box>
      {props.withDivider ? (
        <Divider
          divider={props.divider}
          typography={{
            ...typography,
            primaryTextColor: 'inherit',
          }}
        />
      ) : null}
    </Fragment>
  );
};

const Divider: FC<Pick<SchemaType, 'divider' | 'typography'>> = ({
  divider,
  typography = {},
}) => {
  return divider !== Dividers.NONE ? (
    <Flex
      className="countdown-divider"
      fontFamily={typography.fontFamily}
      fontSize={typography.clockFontSize}
      color={typography.primaryTextColor}
      margin="0 1rem"
      lineHeight="1"
    >
      {divider}
    </Flex>
  ) : (
    <Flex
      className="countdown-divider-none"
      fontSize={typography.clockFontSize}
      marginRight="1rem"
      lineHeight="1"
    />
  );
};
